export default __webpack_public_path__ + "691de095a86b0ad2592d9640feb849a3.png";